<template>
  <v-dialog :value="isOpen"
    persistent
    max-width="450"
    content-class="remove-images-dialog">
    <v-card>
      <dialog-header text="Mark Images" @closeModal="cancelMarkImages" />
      <v-card-text class="pa-5">
        <p>You have selected {{this.proofsheetImagesToMark.length}} images to mark. Click "Confirm" to mark these images.</p>
        <v-form v-model="valid" @submit.prevent="submit">
          <div>
            <label class="modal-label">Eye</label>
          </div>
          <select-with-button
            v-model="eye"
            :items="eyes"
            name="eye"
            v-validate="'required'"
            data-vv-as="Eye"
            :error-messages="errors.collect('eye')"/>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="submit" class="modal-cta">Confirm</v-btn>
        <v-btn text @click="cancelMarkImages" class="modal-cta">Cancel</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialogHeader from "../dialogs/DialogHeader";
import selectWithButton from "../controls/SelectWithButton";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { EYES } from "../../config/config";
export default {
  name: "markImagesDialog",
  components: {
    dialogHeader,
    selectWithButton
  },
  data() {
    return {
      valid: false,
      eye: null,
      eyes: EYES
    };
  },
  computed: {
    ...mapGetters(["proofsheetImagesToMark"]),
    isOpen() {
      return this.proofsheetImagesToMark && this.proofsheetImagesToMark.length;
    }
  },
  methods: {
    ...mapActions(["markImages"]),
    ...mapMutations(["cancelMarkImages", "displayStatus"]),
    submit() {
      this.$validator
        .validateAll()
        .then(valid => {
          if (!valid) return Promise.reject("Please fix all form errors");
          return this.markImages(this.eye);
        })
        .catch(msg => {
          this.displayStatus({ message: msg, level: "error" });
        });
    }
  },
  watch: {
    isOpen() {
      this.eye = null;
    }
  }
};
</script>